import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    console.log("Cmessages controller connected!", this.element)
    this.master = !!this.element.dataset.master
  }

  update(event) {
    console.log("Cmessages controller update! 🍔", event)
    const messageId = event.detail.id
    const messageHtml = event.detail.html
    const visible = event.detail.visible

    if (visible || this.master) {
      let messageElement = this.element.querySelector(messageId)
      if (messageElement) {
        messageElement.outerHTML = messageHtml
      } else {
        this.element.insertAdjacentHTML('beforeend', messageHtml)
      }

      // Find element again since it just got inserted or replaced
      messageElement = this.element.querySelector(messageId)
      // Scroll the nearest scrollable container (prefer the messages container itself)
      const scrollable = this.nearestScrollableAncestor(this.element) || document.scrollingElement || document.documentElement
      // Scroll to the bottom of the scrollable area when a new message arrives
      scrollable.scrollTo({ top: scrollable.scrollHeight, behavior: "smooth" })
    }
  }

  nearestScrollableAncestor(el) {
    let node = el
    while (node) {
      const style = window.getComputedStyle(node)
      const overflowY = style.overflowY
      const overflow = style.overflow
      const isScrollable = (["auto", "scroll"].includes(overflowY) || ["auto", "scroll"].includes(overflow))
      if (isScrollable && node.scrollHeight > node.clientHeight) return node
      node = node.parentElement
    }
    return null
  }
}
